const ValidationError = require('./errors/ValidationError');
const Default = require('./Default');
const { accountType, banks, errors } = require('@transfeeradev/api-enums');

module.exports = class Sicoob extends Default {
  constructor(data) {
    super('Sicoob', data, banks.SICOOB.code);
    this._data.agency = this._removeUnnecessaryLeadingZeros(this._data.agency, this._agencySchemaLength);
    this._data.account = this._removeUnnecessaryLeadingZeros(this._data.account, this._accountSchemaLength);
  }

  _validateAgency() {
    super._validateAgency();

    if (Number(this._data.agency) !== 1 && this._data.account_type === accountType.CONTA_POUPANCA) {
      const error = errors.ptBr.dba.INVALID_AGENCY_ONE;
      throw new ValidationError(
        error.message,
        error.field,
        {
          agency: '1'
        },
        error.code
      );
    }
  }

  _validateAccount(inputErrors) {
    super._validateAccount();
    if (!this._validateAccountDigit()) {
      if (this._tryAccountSuggestion(inputErrors)) {
        return;
      }
      const error = errors.ptBr.dba.INVALID_ACCOUNT_DIGIT;
      throw new ValidationError(
        error.message,
        error.field,
        {
          account_digit: this._getAccountDigit()
        },
        error.code
      );
    }
  }

  _tryAccountSuggestion(inputErrors) {
    const accountSuggestion = this._data.account.substr(0, this._data.account.length - 1);
    const accountDigitSuggestion = this._data.account.substr(this._data.account.length - 1, this._data.account.length);
    if (!this._validateAccountDigit(accountSuggestion, accountDigitSuggestion)) {
      return false;
    }

    const error = errors.ptBr.dba.INVALID_ACCOUNT;
    inputErrors.push(
      new ValidationError(
        error.message,
        error.field,
        {
          account: accountSuggestion
        },
        error.code
      )
    );
    if (+this._data.account_digit !== +accountDigitSuggestion) {
      const error2 = errors.ptBr.dba.INVALID_ACCOUNT_DIGIT;
      inputErrors.push(
        new ValidationError(
          error2.message,
          error2.field,
          {
            account_digit: accountDigitSuggestion
          },
          error2.code
        )
      );
    }
    return true;
  }

  _validateAccountDigit(account = this._data.account, account_digit = this._data.account_digit) {
    return +account_digit === +this._getAccountDigit(account);
  }

  _getAccountDigit(account = this._data.account) {
    const multipliers = [10, 9, 8, 7, 6, 5, 4, 3, 2];
    const bankNumber = this._fillZero(account, this._accountSchemaLength);
    let result = 0;

    for (let i = 0; i < bankNumber.length; i++) {
      result += Number(bankNumber[i]) * multipliers[i];
    }

    result = 11 - (result % 11);
    if (result === 10 || result === 11) {
      return 0;
    }
    return result;
  }

  validate() {
    const errors = [];

    const validateError = e => {
      if (e instanceof ValidationError) {
        errors.push(e);
      } else {
        throw e;
      }
    };

    try {
      this._validateBank();
    } catch (e) {
      validateError(e);
    }

    try {
      this._validateAgency();
    } catch (e) {
      validateError(e);
    }

    try {
      this._validateAccountType();
    } catch (e) {
      validateError(e);
    }

    try {
      this._validateAccount(errors);
    } catch (e) {
      validateError(e);
    }

    return errors;
  }
};
